export const checkout = {
    upload: {
        hero: {
            title: 'Ihr industrieller 3D-Druck Service',
            subtitle:
                'Bestellen Sie in nur wenigen Schritten Ihr 3D-Druck Bauteil.',
        },
        choose3DFile: '3D-Datei auswählen',
        startDemo: 'Demo starten',
        dontHaveAFileYet: 'Keine 3D-Datei parat?',
        dragAndDrop3DFile:
            '3D-Datei hierhin ziehen und per Drag & Drop hochladen',
        or: 'oder',
        defaultHeader: 'Online Bestellportal',
        defaultSubtitle: 'Laden Sie hier Ihre Daten hoch',
        chooseDifferent3DFile: 'Andere Datei hochladen',
        addAnother3DFile: 'Weitere Datei hochladen',
        uploadState: {
            convertingToSTL: 'Step-Datei wird konvertiert',
            analyzing: 'Objekt wird analysiert',
            convertingToTRF: 'Datei wird konvertiert',
            analyzingDimensions: 'Objektgröße wird berechnet',
            fileIsUploading: 'Datei wird hochgeladen',
            repairing: 'Datei wird repariert',
        },
    },
    analysis: {
        printQualityInfo: {
            tooLargeHeader: 'Das Objekt ist zu groß für jeden Druck-Modus!',
            notPrintableHeader:
                'Das Bauteil ist in dieser Konfiguration nicht druckbar!',
            notPrintableBody:
                "Bitte wenden Sie sich über das Kontaktformular an unseren <a href='/kontakt#cart-steps' target='_blank'>Support</a> um ein unverbindliches Angebot zu erhalten.",
            mightCauseProblemsHeader:
                'Ihr Druckergebnis kann verbessert werden:',
            mightCauseProblemsBody:
                "Teile des Modells könnten bei der gewählten Skalierung zu dünn sein. Siehe <a href='/produktion/tipps-und-tricks-im-3d-druck#cart-steps' target='_blank'>Design-Guidelines</a>-",
            filePrintableHeader: '3D-Druck ist möglich:',
            filePrintableBody:
                "Unser automatischer Modellcheck hat keine Probleme gefunden. Bitte beachten Sie dennoch unserer <a href='/produktion/tipps-und-tricks-im-3d-druck#cart-steps' target='_blank'>Design-Guidelines</a>.",
            tooLargeForSelectedPrintmodeHeader:
                'Das Objekt ist zu groß für den gewählten Druck-Modus!',
            tooLargeForSelectedPrintmodeBody: 'Bitte setzen Sie sich unter <a href="mailto:info-as@murtfeldt.de">info-as@murtfeldt.de</a> mit uns in Verbindung.',
            printabilityIsBeingCalculated: 'Druckbarkeit wird berechnet',
        },
    },
    configure: {
        objectMeasurements: 'Ihr Objekt hat die folgenden Abmessungen:',
        '3dRender': '3D-Ansicht',
        wallThicknesses: 'Wandstärken',
        repairData: 'ReparaturDaten',
        inputLabels: {
            objectName: 'Objektname',
            givenUnitOfLength: 'Welche Längeneinheit wurde verwendet?',
            materialAndColor: 'Bitte wählen Sie Material und Farben:',
            scale: 'Skalierung',
            unit: 'Einheit',
            quantity: 'Anzahl',
            finishOptions: 'Oberflächenveredelung',
            untreated: 'Unbehandelt',
        },
        rotateObjectInstruction:
            'Drehen Sie das Objekt durch ziehen mit der Maus',
    },
    nextStep: 'Weiter',
    addToCart: 'In den Warenkorb',
    steps: {
        choose3DFile: '3D-Datei hochladen',
        choosePrintMode: 'Druckeinstellungen wählen',
        checkout: 'Warenkorb',
    },
    cart: {
        label: 'Warenkorb',
        cartIsEmpty: 'Der Warenkorb ist leer.',
        actionLabels: {
            addToCart: 'In den Warenkorb',
            generateQuote: 'Angebot anfordern',
            completeOrder: 'Jetzt bestellen',
            editPaymentDetails: 'Zahlungsinformationen bearbeiten',
            chooseFinishes: 'Weiter',
            goBack: 'Zurück',
            close: 'Schließen',
        },
        noTaxIncluded: 'Steuern nicht mit inbegriffen',
        includingVAT: 'alle Preise inklusive MwSt. (falls anzuwenden)',
        includingXPercentTaxes: 'alle Preise inklusive {taxRate} % MwSt',
        plusXPercentTaxes: 'zzgl. {taxRate} % MwSt',
        isPiecePrice: 'Preis pro Stück',
        isFullPrice: 'Gesamt',
        itemLabels: {
            name: 'Artikel',
            namePlural: 'Artikel',
            size: 'Größe in ',
            printMode: 'Material / Farbe',
            quantity: 'Anzahl',
            priceSingle: 'Stück',
            priceSum: 'Gesamt',
            delete: 'Löschen',
            attachments: 'Anhänge',
            uploadAttachment: 'Anhang hochladen',
        },
    },
    orderStatusLabels: {
        QUOTE_GENERATED: 'Angebot angefordert',
        ORDER_RECEIVED: 'Bestellung eingegangen',
        READY_FOR_PROCESSING: 'Bereit zur Abfertigung',
        CUSTOMER_CONTACTED: 'Kunde kontaktiert',
        FILES_PRINTABLE: 'Dateien druckbar',
        FILES_NOT_PRINTABLE: 'Dateien nicht druckbar',
        SUPPLIER_REQUEST_SENT: 'Anfrage an Zulieferer Versendet',
        IN_PRODUCTION: 'Teile in Produktion',
        PARTS_DEFECTIVE: 'Teile defekt',
        PARTS_REVIEWED: 'Teile fehlerfrei',
        ORDER_CANCELLED: 'Auftrag abgebrochen',
        ORDER_COMPLETED: 'Auftrag abgeschlossen',
        UNKNOWN: 'Offen',
    },
    paymentMethodLabels: {
        prepaid: 'Vorkasse',
        billing: 'Auf Rechnung',
        quote: 'Angebot angefordert',
        paypal: 'PayPal',
    },
    productionTime: 'Produktionszeit',
    deliveryTime: 'Lieferzeit',
    productionTimeDays: '0 Arbeitstage | 1 Arbeitstag | {n} Arbeitstage ',
    defaultTermsOfPayment: '10 Tage netto',
    paymentDetails: {
        customerAndPaymentDetails: 'Kunde und Zahlungsmethode',
        completeYourOrder: 'Schließen Sie Ihren Auftrag ab',
        customer: 'Kunde',
        billingAddress: 'Rechnungsadresse',
        shippingAddress: 'Lieferadresse',
        mailing: 'E-Mails',
        address: 'Adresse',
        inputLabels: {
            firstName: 'Vorname',
            lastName: 'Nachname',
            email: 'E-Mail',
            phone: 'Telefon',
            company: 'Firma oder Abteilung',
            referenceNumber: 'Referenznummer',
            street: 'Straße und Hausnummer',
            postalCode: 'Postleitzahl',
            city: 'Ort',
            country: 'Land',
            shippingAddressDiffersFromBillingAddress:
                'abweichend von Rechnungsadresse',
            paymentMethod: 'Zahlungsmethode',
            vatRegistrationNumber: 'USt-ID',
            businessOrPrivateCustomer: 'Sie sind:',
            businessCustomer: 'Firmenkunde',
            privateCustomer: 'Privatkunde',
            saveNewAddress:
                'Neue Adresse für meinen nächsten Auftrag speichern',
            useSeperateBillingEmail:
                'Eine zweite E-Mail Adresse für den Rechnungsversand hinterlegen',
            primaryEmail: 'Auftragsbestätigung und Statusupdates an',
            billingEmail: 'Rechnung zusätzlich an',
        },
        paymentMethod: 'Zahlungsmethode',
    },
    finaliseOrder: {
        buyNow: 'Zahlungspflichtig bestellen',
        goToPayPal: 'Weiter zu PayPal',
        getQuote: 'Angebot anfordern',
        thankYouForOrdering: 'Vielen Dank für Ihre Bestellung.',
        paymentConfirmationSentTo:
            'Wir haben Ihnen eine Zahlungsbestätigung per E-Mail an <span class="has-text-primary">{email}</span> versendet.',
    },
    quoteGenerated: {
        headline: 'Vielen Dank für Ihre Anfrage',
        emailSentTo:
            'Wir haben ein Angebot per E-Mail an <span class="has-text-primary">{email}</span> versendet.',
        emailSent: 'Wir haben ein Angebot per E-Mail an Sie versendet',
    },
    orderCompleted: {},
};
